export function scrollToPricing() {
  const search = new URLSearchParams(window.location.search)
  const pricing = search.get('pricing')
  if (pricing) {
    const pricingEl = document.querySelector(`.pricing.pricing--${pricing}`)
    if (pricingEl) {
      pricingEl.scrollIntoView()
    }
  }
}
export function scrollToButtons() {
  const buttons = document.querySelectorAll<HTMLElement>('[data-scroll-to]')
  if (buttons) {
    for (const btn of buttons) {
      const scrollTo = btn.dataset.scrollTo
      console.log(btn)
      if (scrollTo) {
        const scrollToEl = document.querySelector(scrollTo)
        if (scrollToEl) {
          btn.addEventListener('click', () => {
            scrollToEl.scrollIntoView({
              behavior: 'smooth',
            })
          })
        }
      }
    }
  }
}
